module.exports = __webpack_public_path__ + "static/img/14.6e454c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/14.png
// module id = dGbS
// module chunks = 2